import { render, staticRenderFns } from "./CourseStructureItem.vue?vue&type=template&id=b46fd144"
import script from "./CourseStructureItem.vue?vue&type=script&lang=js"
export * from "./CourseStructureItem.vue?vue&type=script&lang=js"
import style0 from "./CourseStructureItem.vue?vue&type=style&index=0&id=b46fd144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports